import { apiClient } from './api'
import type { ApiResponse } from '@/types/common'
import type { Course, CourseFilters } from '@/types/course'
import type { CreateCourseRequest, UpdateCourseRequest } from '@/types/api'

export const courseService = {
  getCourses: async (filter?: CourseFilters): Promise<ApiResponse<Course[]>> => {
    return apiClient.get<Course[]>('/courses', {
      params: filter,
    })
  },

  getCourseById: async (id: string): Promise<ApiResponse<Course>> => {
    return apiClient.get<Course>(`/courses/${id}`)
  },

  createCourse: async (data: CreateCourseRequest): Promise<ApiResponse<Course>> => {
    return apiClient.post<Course>('/courses', data)
  },

  updateCourse: async (id: string, data: UpdateCourseRequest): Promise<ApiResponse<Course>> => {
    return apiClient.put<Course>(`/courses/${id}`, data)
  },

  deleteCourse: async (id: string): Promise<ApiResponse<void>> => {
    return apiClient.delete<void>(`/courses/${id}`)
  },

  publishCourse: async (id: string): Promise<ApiResponse<Course>> => {
    return apiClient.put<Course>(`/courses/${id}/publish`)
  },

  unpublishCourse: async (id: string): Promise<ApiResponse<Course>> => {
    return apiClient.put<Course>(`/courses/${id}/unpublish`)
  },

  getCourseModules: async (courseId: string): Promise<ApiResponse<import('@/types/course').Module[]>> => {
    return apiClient.get<import('@/types/course').Module[]>(`/courses/${courseId}/modules`)
  },

  setDefaultCommission: async (
    courseId: string,
    commissionType: 'percentage' | 'fixed',
    commissionValue: number
  ): Promise<ApiResponse<Course>> => {
    return apiClient.put<Course>(`/courses/${courseId}/default-commission`, {
      commission_type: commissionType,
      commission_value: commissionValue,
    })
  },

  removeDefaultCommission: async (courseId: string): Promise<ApiResponse<Course>> => {
    return apiClient.delete<Course>(`/courses/${courseId}/default-commission`)
  },
}
